import * as React from "react"
import { type DigitsRoute } from "@digits-shared/components/Router/DigitsRoute"
import useRouter from "@digits-shared/hooks/useRouter"
import QueryBuilder from "src/frontend/components/OS/Applications/Search/QueryBuilder"
import type { SearchQuerySource } from "src/frontend/components/OS/Applications/Search/shared"
import { useFrontendPathGenerator } from "src/frontend/hooks/useFrontendPathGenerator"
import routes from "src/frontend/routes"
import { DigitsSearchBox } from "./DigitsSearchBox"

interface HeaderSearchBoxProps {
  className?: string
  autoFocus?: boolean
  initialValue?: string
  isSearchActive?: boolean
  isSearchRequestInFlight?: boolean
  onClear?: () => void
  isDisabled?: boolean
  onSubmit?: (text: string) => void
  searchRoute?: DigitsRoute
}

export const HeaderSearchBox: React.FC<HeaderSearchBoxProps> = ({
  className,
  autoFocus = false,
  initialValue,
  isSearchActive,
  isSearchRequestInFlight,
  onClear,
  isDisabled,
  onSubmit,
  searchRoute = routes.search,
}) => {
  const { history, location } = useRouter()
  const generatePath = useFrontendPathGenerator()

  const builder = React.useMemo(() => new QueryBuilder(location.queryParams), [location])
  const handleSubmit = React.useCallback(
    (text: string) => {
      if (!text.trim()) return

      if (onSubmit) {
        onSubmit(text)
        return
      }

      const urlParams = builder.setText(text).buildUrlParams()
      const path = generatePath(searchRoute, urlParams)
      const source: SearchQuerySource = "searchbox"
      history.push(path, { source, sourceLocation: location.fullPathname })
    },
    [onSubmit, builder, generatePath, searchRoute, history, location.fullPathname]
  )

  return (
    <DigitsSearchBox
      className={className}
      autoFocus={autoFocus}
      initialValue={initialValue}
      isSearchActive={isSearchActive}
      isSearchRequestInFlight={isSearchRequestInFlight}
      onClear={onClear}
      isDisabled={isDisabled}
      onSubmit={handleSubmit}
    />
  )
}
